import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { requestPasswordReset } from '../services/auth';

const ResetPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const response = await requestPasswordReset({ email });

    setLoading(false);

    if (response.error) {
      setError(response.error);
    } else {
      setSuccess(true);
    }
  };

  if (success) {
    return (
      <div className="page-container">
        <div className="auth-container">
          <h1>Check Your Email</h1>
          <div className="success-message" style={{
            padding: '20px',
            backgroundColor: '#efe',
            border: '1px solid #cfc',
            borderRadius: '4px',
            marginBottom: '20px',
            color: '#060',
            textAlign: 'center'
          }}>
            <p>
              If an account exists with <strong>{email}</strong>, you will receive a password reset link.
            </p>
            <p style={{ marginTop: '10px' }}>
              Please check your email and follow the instructions to reset your password.
            </p>
          </div>
          <div className="auth-links">
            <p>
              <Link to="/login">Return to Login</Link>
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <div className="auth-container">
        <h1>Reset Password</h1>
        <p>Enter your email address and we'll send you a link to reset your password.</p>

        {error && (
          <div className="error-message" style={{
            padding: '12px',
            backgroundColor: '#fee',
            border: '1px solid #fcc',
            borderRadius: '4px',
            marginBottom: '20px',
            color: '#c00'
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="your@email.com"
              disabled={loading}
            />
          </div>

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        <div className="auth-links">
          <p>
            Remember your password? <Link to="/login">Login here</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
